<div class="admin-remark-exception-container">
    <article class="container mb-4 content-container">
        <header class="columns" id="remark-heading">
            <div class="column">
                <a (click)="goToRemark()" class="back-icon is-flex is-align-items-center">
                    <mat-icon fontIcon="arrow_back" class="back-icon mr-2" />
                    <span>Tillbaka till anmärkning</span>
                </a>
                @if (isEditMode) {
                    <h1 class="has-text-weight-bold mt-3 is-size-4-mobile is-size-3-tablet">Uppdatera undantag</h1>
                } @else {
                    <h1 class="has-text-weight-bold mt-3 is-size-4-mobile is-size-3-tablet">Skapa undantag</h1>
                }
            </div>
        </header>
        @if (isLoading$ | async) {
            <section class="columns" aria-label="Laddar sida, ikon och text">
                <div class="column">
                    <span class="mdi mdi-loading mdi-spin mdi-24px">Laddar sida...</span>
                </div>
            </section>
        } @else {
            <form [formGroup]="form">
                <section class="columns" aria-label="Formulär för att skapa undantag">
                    <div class="column m-1">
                        <div class="form-section">
                            <div class="traffic-year-buttons">
                                <mat-label>
                                    Välj trafikår
                                    @for (data of trafficData; track data.name) {
                                        <button mat-raised-button color="{{selectedYear.name === data.name ? 'primary' : ''}}"
                                                (click)="toggleTrafficYear(data.name)">{{ data.name }}</button>
                                    }
                                </mat-label>
                            </div>
                        </div>
                        <div class="form-section">
                            <div class="field is-horizontal">
                                <div class="field-body">
                                    <div style="display: flex">
                                        <mat-form-field class="field--remark-name">
                                            <mat-label>Namnge undantag</mat-label>
                                            <input matInput formControlName="name" type="text"
                                                   id="remark_name" name="remark_name" maxlength="50">
                                            <mat-hint align="end">{{ form.controls.name.value.length }} / 50 tecken</mat-hint>
                                            @if (form.controls.name.hasError('required') && form.controls.name.touched) {
                                                <div>
                                                    <mat-error>Obligatoriskt fält. Namn måste fyllas i.</mat-error>
                                                </div>
                                            }
                                        </mat-form-field>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="form-section">
                            <div class="train-number-search-container">
                                <label>Välj de tåg undantaget avsker</label>
                                <div class="train-number-search">
                                    @for (trainId of remarkData?.trainNumbers; track trainId) {
                                        <button class="train-number-search__button"
                                                mat-raised-button
                                                color="{{hasSelectedTrain(trainId) ? 'primary' : ''}}"
                                                (click)="toggleSelectedTrain(trainId)"
                                        >{{ trainId }}</button>
                                    }
                                </div>
                            </div>
                        </div>
                        <div class="pull-right">
                            <button mat-raised-button (click)="goToRemark()">Avbryt</button>

                            @if (isEditMode) {
                                <button mat-flat-button color="primary" (click)="updateException()">Uppdatera undantag</button>
                            } @else {
                                <button mat-flat-button color="primary" (click)="createException()">Skapa undantag</button>
                            }
                        </div>

                        <div class="form-section datepicker-section">
                            <p>Välj dagar när suffixet inte ska visas för det valda tåget eller tågen</p>

                            <calendar-section
                                [form]="form"
                                [selectedYear]="selectedYear"
                                [remarkData]="remarkData"
                                [exceptionId]="exceptionId"
                            />
                        </div>
                    </div>
                </section>
            </form>
        }
        @if (!(isLoading$ | async)) {
            <div class="footer">
                <button mat-raised-button (click)="goToRemark()">Avbryt</button>

                @if (isEditMode) {
                    <button mat-raised-button color="primary" (click)="updateException()">Uppdatera undantag</button>
                }

                @if (!isEditMode) {
                    <button mat-raised-button color="primary" (click)="createException()">Skapa undantag</button>
                }
            </div>
        }
    </article>
</div>
